import { IconRenderer } from 'braid-design-system';
import type { FC } from 'react';

import type { IconProps } from './types';

const Icon: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.25 6.00975C14.2515 5.14033 14.0371 4.28415 13.626 3.51807C13.2149 2.75199 12.62 2.1 11.8946 1.62064C11.1693 1.14128 10.3363 0.849555 9.47037 0.771661C8.60445 0.693767 7.73274 0.832142 6.93351 1.17436C6.13428 1.51658 5.43254 2.05193 4.89132 2.73234C4.35009 3.41275 3.98632 4.21693 3.83266 5.07266C3.679 5.92839 3.74026 6.80888 4.01094 7.63509C4.28163 8.4613 4.75326 9.20734 5.3835 9.80625L4.506 16.4107C4.48715 16.5508 4.50827 16.6934 4.56692 16.822C4.62557 16.9506 4.71937 17.06 4.83751 17.1376C4.95564 17.2152 5.0933 17.2579 5.23462 17.2606C5.37594 17.2634 5.51517 17.2262 5.63625 17.1532L9 15.1342L12.3638 17.1532C12.4848 17.226 12.624 17.263 12.7652 17.2601C12.9063 17.2573 13.0439 17.2146 13.1619 17.137C13.2799 17.0594 13.3736 16.9501 13.4322 16.8216C13.4908 16.6931 13.512 16.5507 13.4932 16.4107L12.6172 9.8055C13.1328 9.31691 13.5434 8.72846 13.8241 8.07601C14.1048 7.42356 14.2497 6.72077 14.25 6.0105V6.00975ZM5.25 6.00975C5.25 5.01519 5.64509 4.06136 6.34835 3.3581C7.05161 2.65484 8.00544 2.25975 9 2.25975C9.99456 2.25975 10.9484 2.65484 11.6517 3.3581C12.3549 4.06136 12.75 5.01519 12.75 6.00975C12.75 7.00431 12.3549 7.95814 11.6517 8.6614C10.9484 9.36466 9.99456 9.75975 9 9.75975C8.00544 9.75975 7.05161 9.36466 6.34835 8.6614C5.64509 7.95814 5.25 7.00431 5.25 6.00975ZM11.802 15.066L9.38625 13.617C9.26952 13.5472 9.13603 13.5103 9 13.5103C8.86397 13.5103 8.73048 13.5472 8.61375 13.617L6.19875 15.066L6.771 10.7557C7.46735 11.0876 8.229 11.2598 9.00037 11.2598C9.77175 11.2598 10.5334 11.0876 11.2297 10.7557L11.802 15.066ZM0.75 2.25C1.39912 1.92545 1.92545 1.39911 2.25 0.75C2.57455 1.39911 3.10088 1.92545 3.75 2.25C3.10088 2.57455 2.57455 3.10088 2.25 3.75C1.92545 3.10088 1.39912 2.57455 0.75 2.25Z"
      fill="#2E3849"
    />
    <path
      d="M15 9.75L15.75 8.25L16.5 9.75L18 10.5L16.5 11.25L15.75 12.75L15 11.25L13.5 10.5L15 9.75Z"
      fill="#2E3849"
    />
  </svg>
);

export const SparklingBadgeIcon: FC<IconProps> = (props) => (
  <IconRenderer>
    {({ className }) => <Icon className={`${className} ${props.className}`} />}
  </IconRenderer>
);
